import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { updateEmployee, AddOrUpdateEmployeeApiModel, EmployeeModel } from "@tCentro/Services/CENAdminEmployeeService";

export interface UpdateEmployeeParameter extends HasOnSuccess<EmployeeModel>, HasOnError<string> {
    model: AddOrUpdateEmployeeApiModel;
}

type HandlerType = ApiHandler<UpdateEmployeeParameter, { apiResult: EmployeeModel }>;

export const UpdateEmployee: HandlerType = async props => {
    try {
        const result = await updateEmployee(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result as EmployeeModel);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to update employee");
        }
    }
};

export const chain = [UpdateEmployee];
const updateEmployeeData = createHandlerChainRunner(chain, "updateEmployeeData");
export default updateEmployeeData;
